import React from 'react';
import { graphql, Link } from 'gatsby';
import Img from 'gatsby-image';

import {
    IntroHolder,
    TwoColumns,
    Sidebar,
    Content,
} from '@bahaide/shared/components/InnerPage';

import InnerPage from '../components/InnerPage';

const ArchivTemplate = ({ data, pageContext }) => {
    const posts = data["posts_2017"].edges;
    const { currentPage, numPages } = pageContext;
    const isFirst = currentPage === 1;
    const isLast = currentPage === numPages;
    const prevPage =
        currentPage - 1 === 1
            ? '/200jahrfeier-bahaullah/'
            : '/200jahrfeier-bahaullah/seite/' + (currentPage - 1).toString();
    const nextPage = '/200jahrfeier-bahaullah/seite/' + (currentPage + 1).toString();
    return (
        <InnerPage
            pageType="blog-page"
            title="Beiträge vom 200. Jahrestag der Geburt Bahá'u'lláhs (2017)"
            description="Die vergangenen Beiträge gewidmet für den 200. Jahrestag der Geburt Bahá'u'lláh"
        >
            <IntroHolder title="Beiträge vom 200. Jahrestag der Geburt Bahá'u'lláhs (2017)" />
            <TwoColumns>
                <Content>
                    {posts.map(({ node }, id) => {
                        return (
                            <article className="post-preview" key={id}>
                                <div className="text-holder">
                                    <h2 className="text-blue-900">
                                        <Link
                                            to={`/200jahrfeier-bahaullah/post${node.childMarkdownRemark.fields.slug}`}
                                        >
                                            {node.childMarkdownRemark.frontmatter.title}
                                        </Link>
                                    </h2>
                                    <p>{node.childMarkdownRemark.excerpt}</p>
                                </div>
                            </article>
                        );
                    })}
                    <nav className="navigation pagination" role="navigation">
                        <div className="nav-links">
                            {!isFirst && (
                                <Link
                                    to={prevPage}
                                    className="prev page-numbers"
                                    rel="prev"
                                >
                                    Neuere Beiträge
                                </Link>
                            )}
                            {!isLast && (
                                <Link
                                    to={nextPage}
                                    className="next page-numbers"
                                    rel="next"
                                >
                                    Ältere Beiträge
                                </Link>
                            )}
                        </div>
                    </nav>
                </Content>
                <Sidebar />
            </TwoColumns>
        </InnerPage>
    );
};

export default ArchivTemplate;

export const archivQuery = graphql`
    query archiv2017Query($skip: Int!, $limit: Int!) {
        posts_2017: allFile(filter: {sourceInstanceName: {eq: "posts-2017"}}, sort: {fields: childMarkdownRemark___frontmatter___title, order: ASC}, limit: $limit, skip: $skip) {
            edges {
                node {
                    childMarkdownRemark {
                        frontmatter {
                            title
                        }
                        excerpt(pruneLength: 70, format: PLAIN)
                        fields {
                            slug
                        }
                    } 
                }
            }
        }
    }
    
`;
